import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Rating from '../../atoms/inputs/Rating'
import IconButton from '../../atoms/inputs/IconButton'
import { EvaluationIcon } from '../../atoms/display/Icons'
import { FlexRow } from '../../atoms/layout/Flex'
import { CompanyActions } from '../../../store/company'
import { CompanySelectors } from '../../../store/company/selectors'
import { useClientEvaluationDialog } from '../../../hooks/useDialog'

type Props = {
  companyId: string
}

export default function ClientEvaluationRatingView({ companyId }: Props) {
  const clientDetails = useSelector(CompanySelectors.clientDetails)
  const dispatch = useDispatch()
  const clientDetail = clientDetails?.find((detail) => detail.id === companyId)
  const clientEvaluationDialog = useClientEvaluationDialog()

  useEffect(() => {
    dispatch(CompanyActions.fetchClientDetails())
  }, [dispatch])

  const handleEvaluationDialog = () => {
    clientEvaluationDialog.open(companyId)
  }

  if (clientDetail == null) {
    return <></>
  }

  return (
    <FlexRow>
      <Rating
        max={3}
        value={clientDetail.evaluation?.totalPoint}
        label={`${clientDetail.evaluation?.totalPoint.toFixed(1) ?? '--'}`}
        readOnly
      />
      <IconButton label="編集" onClick={handleEvaluationDialog}>
        <EvaluationIcon size={24} />
      </IconButton>
    </FlexRow>
  )
}
